<template>
  <div class="mb-4">
    <b-card
      bg-variant="dark"
      :header="userData.name"
      text-variant="white"
      class="text-center my-4"
    >
      <b-card-text>ひとこと : {{ userData.comment }}</b-card-text>
      <b-card-text>好きなジャンル : {{ userData.genres }}</b-card-text>
      <b-card-text>読んだ本 : {{ userData.books.length }}</b-card-text>
      <b-card-text>投稿した問い : {{ userData.questions.length }}</b-card-text>
      <b-card-text
        >お気に入りした数 : {{ userData.favQuestions.length }}</b-card-text
      >
      <b-card-text>follow : {{ userData.follows.length }}</b-card-text>
      <b-card-text>follower : {{ userData.followers.length }}</b-card-text>
      <div v-if="$store.getters.isSignedIn">
        <b-button v-if="isMyPage" @click="goToSetting">設定</b-button>
        <div v-else>
          <b-button
            variant="outline-info"
            v-if="!nowFollowing"
            @click="follow($route.params.userId)"
            >フォロー</b-button
          >
          <b-button
            variant="info"
            v-else
            @click="unfollow($route.params.userId)"
            >アンフォロー</b-button
          >
        </div>
      </div>
    </b-card>

    <div>
      <b-tabs content-class="mt-3" align="center">
        <b-tab title="読んだ本" active>
          <div class="books-wrapper">
            <BookCard
              :book="book"
              v-for="(book, index) in books"
              :key="index"
            />
          </div>
        </b-tab>
        <b-tab title="投稿した問い">
          <div class="questions-wrapper">
            <div v-for="(question, index) in questions" :key="index">
              <!-- 問いのカード -->
              <QuestionCard :question="question" />
            </div>
          </div>
        </b-tab>
        <b-tab title="お気に入りした問い">
          <div class="questions-wrapper">
            <div v-for="(question, index) in favQuestions" :key="index">
              <!-- 問いのカード -->
              <QuestionCard :question="question" />
            </div>
          </div>
        </b-tab>
        <b-tab title="フォロー">
          <div class="users-wrapper">
            <b-list-group>
              <b-list-group-item
                class="d-flex align-items-center"
                :href="'/user/' + follow.id"
                v-for="(follow, index) in follows"
                :key="index"
              >
                <b-avatar class="mr-3"></b-avatar>
                <span class="mr-auto">{{ follow.name }}</span>
              </b-list-group-item>
            </b-list-group>
            <div></div>
          </div>
        </b-tab>
        <b-tab title="フォロワー">
          <div class="users-wrapper">
            <b-list-group>
              <b-list-group-item
                class="user-list-item mb-2"
                :href="'/user/' + follower.id"
                v-for="(follower, index) in followers"
                :key="index"
              >
                <b-avatar class="mr-3"></b-avatar>
                <span>{{ follower.name }}</span>
              </b-list-group-item>
            </b-list-group>
            <div></div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import { db } from "@/firebase";
import QuestionCard from "@/components/QuestionCard.vue";
import BookCard from "@/components/BookCard.vue";

export default {
  data: function() {
    return {
      userData: [],
      books: [],
      questions: [],
      favQuestions: [],
      follows: [],
      followers: [],
      isMyPage:
        this.$store.getters.isSignedIn &&
        this.$route.params.userId == this.$store.getters.user.uid,
      nowFollowing: false
    };
  },
  components: {
    QuestionCard,
    BookCard
  },
  methods: {
    //ユーザー関連のデータ取得
    fetchData() {
      //データ更新用
      this.books = [];
      this.questions = [];
      this.favQuestions = [];
      this.follows = [];
      this.followers = [];
      // ユーザーIDからユーザーデータを取得
      db.collection("users")
        .doc(this.$route.params.userId)
        .get()
        .then(snapshot => {
          this.userData = snapshot.data();
          // ユーザーデータの本ID配列から本コレクションデータを取得
          snapshot.data().books.forEach(book => {
            db.collection("books")
              .doc(book)
              .get()
              .then(snapshot => {
                this.books.push({
                  id: book,
                  author: snapshot.data().author,
                  bookTitle: snapshot.data().bookTitle,
                  category: snapshot.data().category,
                  imageURL: snapshot.data().imageURL
                });
              });
          });
          // ユーザーデータの問いID配列から問いコレクションデータを取得
          snapshot.data().questions.forEach(q => {
            db.collection("questions")
              .doc(q)
              .get()
              .then(snapshot => {
                const questionData = snapshot.data();
                questionData.id = snapshot.id;
                this.questions.push(questionData);
              });
          });
          // ユーザーデータのお気に入り問いID配列から問いコレクションデータを取得
          snapshot.data().favQuestions.forEach(q => {
            db.collection("questions")
              .doc(q)
              .get()
              .then(snapshot => {
                const questionData = snapshot.data();
                questionData.id = snapshot.id;
                this.favQuestions.push(questionData);
              });
          });
          // ユーザーデータのフォローID配列からユーザーコレクションデータを取得
          snapshot.data().follows.forEach(follow => {
            db.collection("users")
              .doc(follow)
              .get()
              .then(snapshot => {
                this.follows.push({ id: follow, name: snapshot.data().name });
              });
          });
          // ユーザーデータのフォロワーID配列からユーザーコレクションデータを取得
          snapshot.data().followers.forEach(follower => {
            db.collection("users")
              .doc(follower)
              .get()
              .then(snapshot => {
                this.followers.push({
                  id: follower,
                  name: snapshot.data().name
                });
              });
          });
        });
    },
    goToBookDetail(id) {
      this.$router.push("/book/" + id);
    },
    goToSetting() {
      this.$router.push("/setting");
    },
    follow(id) {
      console.log(id);
      // 自分のフォロー配列に追加
      const follows = this.$store.getters.user.follows;
      follows.push(id);
      this.$store.dispatch("updateUserData", { follows: follows });
      // 相手のフォロワー配列に追加
      db.collection("users")
        .doc(id)
        .update({
          followers: firebase.firestore.FieldValue.arrayUnion(
            this.$store.getters.user.uid
          )
        })
        .then(function() {
          console.log("Document successfully updated!");
        })
        .catch(function(error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
      this.nowFollowing = true;
    },
    unfollow(id) {
      console.log(id);
      // 自分のフォロー配列から削除
      const follows = this.$store.getters.user.follows;
      follows.forEach((follow, index) => {
        if (follow == id) {
          follows.splice(index, 1);
        }
      });
      this.$store.dispatch("updateUserData", { follows: follows });
      // 相手のフォロワー配列から削除
      db.collection("users")
        .doc(id)
        .update({
          followers: firebase.firestore.FieldValue.arrayRemove(
            this.$store.getters.user.uid
          )
        })
        .then(function() {
          console.log("Document successfully updated!");
        })
        .catch(function(error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
      this.nowFollowing = false;
    }
  },
  created() {
    this.fetchData();
    if (this.$store.getters.user.follows.includes(this.$route.params.userId)) {
      this.nowFollowing = true;
    }
  }
};
// http://localhost:8080/mypage/vMzz8gpSY7VBcUiVDKuY
</script>

<style lang="scss">
.users-wrapper {
  margin: 0px auto;
  justify-content: center;
}

.user-list-item {
  max-width: 500px;
  margin: 0 auto;
  text-align: left !important;
}
</style>
